var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "step",
    {
      attrs: {
        title: _vm.title,
        id: "validation",
        description: _vm.description,
        component: _vm.component,
      },
    },
    [
      _vm.initialized
        ? _c(
            "div",
            { staticClass: "flex-grow flex flex-col pb-4" },
            [
              _c(
                "toolbar",
                [
                  _c("div", { staticClass: "flex-grow" }),
                  _vm._v(" "),
                  _c("step-pager", {
                    staticClass: "my-1",
                    attrs: { disabled: !_vm.isValid },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.hasEnrichments
                ? _c("ls-grid", {
                    key: "basic-validation",
                    staticClass: "w-full flex-grow",
                    attrs: {
                      "external-set-ids": [_vm.loanListId],
                      domain: _vm.domainId,
                      validationId: _vm.validationId,
                      "defaults-key": "valuation-step",
                      views: "",
                      "column-filters": "",
                      validations: "",
                      "show-validation-drawer": "",
                      "export-to-excel": "",
                      "show-dev-messages": "",
                    },
                  })
                : _c("ls-grid", {
                    key: "enrichment-validation",
                    staticClass: "w-full flex-grow",
                    attrs: {
                      queryPropOverrides: {
                        scratchpadParams: {
                          packageKeys: ["LoanId"],
                          actionDate: null,
                          filterChoice: 4,
                        },
                        scratchpadPath: _vm.scratchpadPath,
                      },
                      domain: _vm.domainId,
                      validationId: _vm.validationId,
                      "defaults-key": "valuation-step:enrichment",
                      views: "",
                      "column-filters": "",
                      validations: "",
                      "show-validation-drawer": "",
                      "export-to-excel": "",
                      "show-dev-messages": "",
                      "on-before-request-execute": _vm.createValidationNodes,
                    },
                  }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }